import { DatePicker, DatePickerValue } from '@components/ui/date-picker';
import { cn } from '@lib/utils';
import { useFieldContext } from './form';
import { FormDescription, FormErrorMessage, FormField, FormLabel } from './shared.component';

type DatePickerFieldProps = {
  className?: string;
  clearable?: boolean;
  description?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  tooltip?: React.ReactNode;
};

/**
 * A date picker field component integrated with TanStack Form.
 * Stores the date as an ISO date string (YYYY-MM-DD) for backend compatibility.
 */
export function DatePickerField(props: DatePickerFieldProps) {
  const { className, clearable = false, description, label, placeholder, required, tooltip } = props;

  const field = useFieldContext<DatePickerValue | null | undefined>();

  const handleChange = (value: DatePickerValue | null) => {
    field.handleChange(value);
  };

  return (
    <FormField className={cn('w-full', className)}>
      {label && (
        <FormLabel
          htmlFor={field.name}
          required={required}
          tooltip={tooltip}
        >
          {label}
        </FormLabel>
      )}
      {description && <FormDescription>{description}</FormDescription>}
      <DatePicker
        clearable={clearable}
        hasError={!field.state.meta.isValid}
        id={field.name}
        onChange={handleChange}
        placeholder={placeholder}
        value={field.state.value}
      />
      <FormErrorMessage />
    </FormField>
  );
}
